const BASE_LOAD_URL = '/init/load';

const API_BASE_NAME = 'apiBase';
const REDUCER_BASE_NAME = 'reducerBase';

export {
  BASE_LOAD_URL,

  API_BASE_NAME,
  REDUCER_BASE_NAME,
};
